export default __webpack_public_path__ + "static/media/seongdong-social.1d59059e.jpg";